// src/components/footer/Footer.tsx
import React from "react";
import {
  FooterContainer,
  FooterContent,
  Copyright,
  SocialLinksContainer,
  SocialLinks,
  DownloadButton,
} from "./Footer.styled";

interface FooterProps {
  socialLinks?: {
    linkedin?: string;
    github?: string;
    email?: string;
    whatsapp?: string;
  };
  cvUrl?: string;
}

const Footer: React.FC<FooterProps> = ({ socialLinks, cvUrl }) => {
  const currentYear = new Date().getFullYear();
  return (
    <FooterContainer>
      <FooterContent>
        <Copyright>
          © {currentYear} Cassio Silva Takarada. Todos os direitos reservados.
        </Copyright>

        <SocialLinksContainer>
          {cvUrl && (
            <DownloadButton href={cvUrl} download>
              <i className="ph ph-download" style={{ marginRight: "8px" }}></i>
              Download CV
            </DownloadButton>
          )}

          {socialLinks && (
            <SocialLinks>
              {socialLinks.linkedin && (
                <a
                  href={socialLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <i className="ph ph-linkedin-logo"></i>
                </a>
              )}
              {socialLinks.github && (
                <a
                  href={socialLinks.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <i className="ph ph-github-logo"></i>
                </a>
              )}
              {socialLinks.email && (
                <a href={`mailto:${socialLinks.email}`} aria-label="Email">
                  <i className="ph ph-envelope"></i>
                </a>
              )}
              {socialLinks.whatsapp && (
                <a
                  href={`https://wa.me/${socialLinks.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                >
                  <i className="ph ph-whatsapp-logo"></i>
                </a>
              )}{" "}
            </SocialLinks>
          )}
        </SocialLinksContainer>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
